import { PropsWithChildren, createContext } from 'react';
import { ITableCoreResourceContext } from 'components/table/types';
import { ReportResource } from 'types/domain';

const TableCoreResourceContext = createContext<ITableCoreResourceContext<any>>({});

const TableCoreResourceProvider = <N extends ReportResource>(
    props: ITableCoreResourceContext<N> & PropsWithChildren,
) => {
    const { children, ...rest } = props;

    return (
        <TableCoreResourceContext.Provider value={rest}>
            {children}
        </TableCoreResourceContext.Provider>
    );
};

export { TableCoreResourceProvider, TableCoreResourceContext };
